<template>
  <b-modal id="showEvents" ref="showEvents" no-close-on-esc ok-only size="xl">
    <template slot="modal-title">{{$t('eventLog')}}</template>
    <b-table show-empty striped hover class="aco-table"
             :items="events" :fields="eventFields" small>
    </b-table>
  </b-modal>
</template>

<script>
  export default {
    name: 'ShowEvents',
    props: {
      events: { type: Array }
    },
    computed: {
      eventFields () {
        return [
          { key: 'message', label: this.$t('message') },
          { key: 'created', label: this.$t('created'), tdClass: 'text-nowrap', formatter: 'formatTimestamp' },
          { key: 'lastSeen', label: this.$t('lastSeen'), tdClass: 'text-nowrap', formatter: 'formatTimestamp' },
          { key: 'timesSeen', label: this.$t('timesSeen'), tdClass: 'text-nowrap' },
        ]
      }
    }
  }
</script>